import React, { useContext, useEffect, useState } from 'react';
import { getModifiers, getMenuReducerItemDetails } from 'common/utilities/utils';
import { QuantityModifier } from 'molecules/QuantityModifier';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import Single_Arrow_Edit from 'styles/staticAssets/images/Single_Arrow_Edit.svg';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { useDispatch, useSelector } from 'react-redux';
import { fetchItemDetailsAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';

export const CustomizableQuantity = props => {
  const {
    basketLineItemId,
    customizableFoodItemsList,
    SetCustomizableFoodItemsList,
    calculateTotalAmountHandler,
    isEditSelection
  } = props;
  const dispatch = useDispatch();
  const { RESET_MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { MINI_PDP_DATA, FROMFLAGEDIT, EDIT_CLICKED } = START_ORDER_CONSTANTS;
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const foodItem = customizableFoodItemsList[basketLineItemId];
  const menuReducerItemDetails = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  const [showEdit, setShowEdit] = useState(false);
  const [notDefault, setDefault] = useState(false);

  const updateItemQuantity = (item, action) => {
    foodItem.quantity = action === QUANTITY_ACTION.Increase ? foodItem?.quantity + 1 : foodItem?.quantity - 1;
    const tempObj = customizableFoodItemsList;
    tempObj[basketLineItemId] = foodItem;
    SetCustomizableFoodItemsList(tempObj);
    calculateTotalAmountHandler();
  };

  const onClickArrowHandler = () => {
    userOrderStateDispatch({
      type: MINI_PDP_DATA,
      value: { id: foodItem?.foodItems?.id, flag: FROMFLAGEDIT, foodLineId: basketLineItemId },
    });
    userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
    userOrderStateDispatch({
      type: EDIT_CLICKED,
      value: { cartEditClicked: false },
    });
    dispatch(
      fetchItemDetailsAction({
        tenantId: foodItem?.tenantId,
        catalogName: foodItem?.catalog,
        itemId: foodItem?.foodItems?.id,
      }),
    );
    setShowEdit(true);
  };

  useEffect(() => {
    let currentvalue = true;
    foodItem?.modGrps?.forEach(item => {
      currentvalue = currentvalue * item.modifiers[0].isDefault;
    });
    setDefault(currentvalue);
  }, [foodItem.modGrps]);

  useEffect(() => {
    getMenuReducerItemDetails(
      menuReducerItemDetails,
      foodItem,
      userOrderState,
      showEdit,
      dispatch,
      showCustomizationModalAction,
    );
    setShowEdit(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuReducerItemDetails, showEdit]);

  const editSelectionArrowClick = () => {
    return (
      <div className='EditItemsCard' onClick={() => onClickArrowHandler()}>
        <div className='CustomizeOptionModal'>
          <div>
            <div className='DisplayNameFont'>{foodItem?.displayName}</div>
            <div className='customizableProducts-Default'>{getModifiers(foodItem.modGrps)}</div>
          </div>
          <img className='arrow-icon' data-testid='arrow-click-edit' src={Single_Arrow_Edit} alt='Arrow Icon' />
        </div>
      </div>
    );
  };

  const plusAndMinusModifier = () => {
    return (
      <div className='PlusAndMinus'>
        <QuantityModifier
          itemCount={foodItem?.quantity}
          itemQuantity={1}
          data-testid='QuantityModifier_OnClick'
          updateItemQuantity={updateItemQuantity}
          quantityAction={QUANTITY_ACTION}
          maxItemCountPerLineItem={foodItem?.maxItemCountPerLineItem}
          cartItemCount={1}
          hideChild={true}
        />
      </div>
    );
  };

  return (
    <>
      {isEditSelection ? (
        editSelectionArrowClick()
      ) : (
        <div className='CustomizeOptionModal'>
          <div>
            <div className='DisplayNameFont'>{foodItem?.displayName}</div>
            <div className='customizableProducts-Default'>{getModifiers(foodItem.modGrps)}</div>
          </div>
          {plusAndMinusModifier()}
        </div>
      )}
      <div className='LineSeparator'></div>
    </>
  );
};
